/* eslint-env browser, node */
import processPipe from './processPipe';
import precise from './precise';
import VSVC from './data/vesselSVCConstants';
import { VEHICLES } from './constants';
import getSecondYearFeeforBusCategory from './getSecondYearFeeforBusCategory';

function getSecondYearFee(options) {
  const { selectedVehicleType, applySecondYearFee } = options;
  if (
    !selectedVehicleType ||
    (typeof applySecondYearFee !== 'undefined' && applySecondYearFee === false)
  ) {
    return precise(0);
  }

  if (!selectedVehicleType) {
    return precise(0);
  }

  if (selectedVehicleType === VEHICLES.BUSES_TRAILER) {
    return getSecondYearFeeforBusCategory(options);
  }

  const { BFfee } = options;
  const vehicleWeight = options.vehicleWeight || 0;
  let monthsFromNow = options.monthsFromNow;

  if (selectedVehicleType === VEHICLES.VESSELS) {
    monthsFromNow = 12;
  }

  const pipe = processPipe(options.pipe);

  const svc = options.svc;
  const r16 = Number(pipe.r16);
  let r17 = pipe.r17;

  const K = pipe[`r${monthsFromNow}`];
  const W = Math.round(Number(vehicleWeight) / 100);
  let secondYearFee = 0;

  // console.log({ r16, r17, K, W, BFfee, svc, monthsFromNow });

  // vscf12 is just set to zero because in the PDF, this variable
  // is out of scope by the time John is calculating 2ndYear Fees. Outside of the Vessel
  // dropdown, this value can't be seen anywhere even though access is attempted
  // from non-vessel-specific areas). If this is a bug, it is a bug that is
  // being carried over to the web version.
  const vscf12 = 0;

  // Just add up all the Vessel SVC Fees
  const VSsvc = Object.keys(VSVC).reduce((acc, n) => VSVC[n] + acc, 0);

  if (VSsvc !== 4.75) {
    throw new Error('VSsvc should be 4.75 per 9/01/14 fees');
  }

  // TODO: research the PDF to see if the cmm value will ever
  // be anything but 0.00 in this script. I think this value
  // will only ever be 50.00 if there is a commercial vessel
  // fee applied or zero.
  const cmm = 0;

  // Because John liked to do everything on the global state
  // this r17 check is repeated (from the various Vehicle Dropdown onChange handlers)
  // to ensure that r17 will equal the amounts he would specify in the global
  // state (and the code down below should behave as planned, but we can
  // still be modular). This entire module needs to be refactored.

  // From leases dropdown
  if (r17 === 'a12') {
    r17 = (((17.00) + (1.50 * W)) + svc);
  }
  if (r17 === 'tp12') {
    r17 = (((13.50) + (1.50 * W)) + svc);
  }
  if (r17 === 't12') {
    r17 = (((3.50) + (1.50 * W)) + svc);
  }

  // From buses dropdown
  if (r17 === 'b12') {
    r17 = (((((17.00) + (2.00 * W)) / 12) * 12) + (svc));
  }
  if (r17 === 't12') {
    r17 = (((((3.50) + (1.00 * W)) / 12) * 12) + (svc));
  }

  const nr17 = Number(r17);
  const nr16 = Number(r16);

  // should be more than 3 or else choose 13 to 15
  // months on first months options Rsub1a
  if (monthsFromNow > 3) {
    // This is MATCHING ON EVERY SINGLE PIPE THAT EXISTS.
    if (nr16 !== 5 && nr16 !== 6 && nr17 !== 1 && nr17 !== 2 && K !== 'b' && K !== 't') {
      secondYearFee = nr17 + BFfee + cmm;
    }

    // Only Vessels have an r16 of 5 (matches 21 Vessels)
    if ((nr16 === 5) && (nr17 !== 0) && (nr17 !== 1) && (nr17 !== 2) && (K !== 'b') && (K !== 't')) {
      secondYearFee = nr17 + VSsvc + vscf12 + BFfee + cmm;
    }

    // Only Lease have an r16 of 6 (matches 3 Lease Vehicles)
    if (nr16 === 6 && nr17 !== 1 && nr17 !== 2 && ((K !== 'b') || (K !== 't'))) {
      secondYearFee = nr17;
    }

    // 0.00 base tax vessel (antique) (matches 2 vessels)
    if ((nr16 === 5) && (nr17 === 0) && (nr17 !== 1) && (nr17 !== 2) && (K !== 'b') && (K !== 't')) {
      secondYearFee = 3.75 + BFfee + cmm;
    }

    // Certain Trailer or Buses (matches 0 vehicles)
    if (nr17 !== 1 && nr17 !== 2 && ((K === 'b') || (K === 't'))) { // 2nd year on trailers and buses
      secondYearFee = nr17;
    }

    // Exempt and certain vehicles/vessels (matches 50/128 Vehicles/Vessels)
    if (nr17 === 2) {
      alert('not eligible for biennial (2nd year) renewal');
      secondYearFee = 0;
    }
  } else {
    alert('Number of Months chosen above should be more than 3 instead of adding biennial fees (choose 13 to 15 months)');
    secondYearFee = 0;
  }
  return precise(secondYearFee);
}

export default getSecondYearFee;



// WEBPACK FOOTER //
// ./src/modules/getSecondYearFee.js